import { createInMemoryAtom } from '@exodus/atoms';
const initialState = {
    remoteConfigUrl: null,
    error: null,
    loaded: false,
};
const remoteConfigStatusAtomDefinition = {
    id: 'remoteConfigStatusAtom',
    type: 'atom',
    factory: () => createInMemoryAtom({ defaultValue: initialState }),
    dependencies: [],
};
export default remoteConfigStatusAtomDefinition;
